import { StateService } from '@adgate/common/services/state-service';
import { inject } from '@angular/core';
import { CanDeactivateFn } from '@angular/router';

export const RouteDeactivateGuard: CanDeactivateFn<unknown> = (component,currentRoute,currentState,nextState) => 
{
  let stateService: StateService = inject(StateService);

  stateService.data.moduleTitle = "";
  stateService.persist();
  return true;
};
